import { useCallback } from 'react';
export const useValidationErrorEvaluate = errors => {
  const isFormValid = useCallback(() => errors.length === 0, [errors]);
  const isFieldValid = useCallback(fieldName => !errors.find(({
    name
  }) => name === fieldName), [errors]);
  const getFieldErrors = useCallback(fieldName => errors.filter(({
    name
  }) => name === fieldName), [errors]);
  return {
    isFieldValid,
    isFormValid,
    getFieldErrors
  };
};